import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor } from '../_app/store/configureStore.dev';

import store from './store/store';
import App from './App';
import Provider from './components/Provider';
import { StripeProvider } from 'react-stripe-elements';

import { ApolloProvider } from 'react-apollo';
import ApolloClient from 'apollo-boost';
import { ThemeProvider } from 'styled-components';
import { MuiThemeProvider, withStyles } from '@material-ui/core/styles';

import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import '../index.css';
import { components, themes } from '@peachjar/components';
import baseTheme from './app.base.css.theme';
import config from '../config';

const { ModalRoot, ModalProvider } = components;

const STRIPE_API_KEY = config.REACT_APP_STRIPE_PUBLISHABLE_API_KEY || null;
const GRAPHQL_URI = config.REACT_APP_GRAPHQL_URI;
const apolloClient = new ApolloClient({
  uri: GRAPHQL_URI,
  credentials: 'include',
});

console.log('STRIPE API KEY',STRIPE_API_KEY)

// const persistor = persistStore(store);

const AppWrapper = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <ApolloProvider client={apolloClient}>
          <ThemeProvider theme={themes.portal}>
            <ModalProvider>
              <StripeProvider apiKey={STRIPE_API_KEY}>
                <MuiThemeProvider theme={baseTheme}>
                  <Route path="/" component={App} />
                </MuiThemeProvider>
              </StripeProvider>
            </ModalProvider>
          </ThemeProvider>
        </ApolloProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

export default AppWrapper;



// WEBPACK FOOTER //
// ./src/_app/AppWrapper.jsx